import React from 'react';
import { useT } from '@repo/common';
import { REFUND_COLUMN_CLASS as COL } from './refundColumns';

const HeaderItem = ({ children, className, type }) => {
  return (
    <div
      className={`flex justify-center items-center text-center px-1 py-4 gap-[10px] relative z-10 ${className}`}
    >
      <span
        className={`${
          type === 'date'
            ? 'typo-b12 text-text-disable'
            : 'typo-b13Strong text-text-secondary'
        }`}
      >
        {children}
      </span>
    </div>
  );
};

/* 표 머리글은 tabletV(1180px) 이상에서만 보인다. 그 아래는 행이 카드로 바뀐다. */
const RefundsListHeader = () => {
  const t = useT();
  return (
    <div className='hidden tabletV:flex flex-col w-full items-start px-2 bg-grayscale-gray02/30 rounded-t-[30px]'>
      <div className='flex w-full'>
        <HeaderItem className={COL.date} type='date'>
          {t('Date', '일자')}
        </HeaderItem>
        <HeaderItem className={COL.number}>
          {t('Cancellation No.', '취소 번호')}
        </HeaderItem>
        <HeaderItem className={COL.reason}>{t('Reason', '사유')}</HeaderItem>
        <HeaderItem className={COL.user}>{t('User', '사용자')}</HeaderItem>
        <HeaderItem className={COL.amount}>{t('Amount', '금액')}</HeaderItem>
        <HeaderItem className={COL.status}>{t('Status', '상태')}</HeaderItem>
        <div className={`flex justify-center items-center ${COL.icon}`} />
        <div className={`flex justify-center items-center ${COL.icon}`} />
      </div>
      <div className='bg-grayscale-gray02/70 h-5' />
    </div>
  );
};

export default RefundsListHeader;
